module.exports = __webpack_public_path__ + "fontawesome-webfont.b06871f281fee6b241d6.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/fonts/fontawesome-webfont.ttf?v=4.7.0
// module id = ../../../../../src/fonts/fontawesome-webfont.ttf?v=4.7.0
// module chunks = 2